<template>
  <div>
    <div class="head">
      <div class="head_left" style="display:flex;">
        <!-- <span>商品状态</span> -->
        <!-- <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>-->
        <el-input
          placeholder="请输入内容"
          style="width:400px;"
          v-model="goodName"
          class="input-with-select"
        >
          <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
        </el-input>
      </div>
      <div>
        <el-button type="primary" @click="selectProducts">添加活动商品</el-button>
      </div>
    </div>
    <div class="content">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" align="center" label="编号"></el-table-column>
        <el-table-column align="center" label="商品图片">
          <template slot-scope="scope">
            <img style="width:100px;height:100px;" :src="scope.row.logo" alt />
          </template>
        </el-table-column>
        <el-table-column prop="goodName" align="center" label="名称"></el-table-column>
        <el-table-column prop="price" align="center" label="售价（元）"></el-table-column>
        <el-table-column prop="sal_count" align="center" label="总销量"></el-table-column>
        <el-table-column prop="stock" align="center" label="库存"></el-table-column>
        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.stock <= 0 && scope.row.status == 0">缺货</span>
            <span v-if="scope.row.stock < 10 && scope.row.status == 0">库存不足</span>
            <span v-if="scope.row.stock > 10 && scope.row.status == 0">正常</span>
            <span v-if="scope.row.status == 1">下架</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text">退出此活动</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin:30px auto">
        <el-pagination
          @current-change="pageFn()"
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          :page-size="10"
          :total="count"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="选择商品" :visible.sync="centerDialogVisible" @close="closeFn" width="60%" center>
      <div style="margin:20px 0;">
        <el-input
          style="width:300px;"
          placeholder="请输入商品名称\编码"
          maxlength="30"
          v-model="searchValue"
        ></el-input>
        <el-button type="primary" @click="getGoodList(1)">搜索</el-button>
        <el-button type="info" @click="reset">重置</el-button>
      </div>
      <el-table :data="goodTableData" border style="width: 100%">
        <el-table-column align="center" prop="goodName" width="100">
          <template slot-scope="scope">
            <!-- <checkbox :checkbox="scope.row.checked"></checkbox> -->
            <input type="checkbox" v-model="scope.row.checked" />
          </template>
        </el-table-column>
        <el-table-column align="center" prop="goodName" label="商品名称"></el-table-column>
        <el-table-column align="center" prop="price" label="售价" width="180"></el-table-column>
        <el-table-column align="center" prop="stock" label="库存" width="180"></el-table-column>
        <!-- <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="addsgood(scope.row)">选择商品</el-button>
          </template>
        </el-table-column>-->
      </el-table>
      <el-pagination
        @current-change="goodPageFn()"
        layout="prev, pager, next"
        :current-page.sync="GoodPage"
        :page-size="10"
        :total="goodsCount"
      ></el-pagination>
      <div style="height:45px">
        <span class="dialog-footer" style="float:right">
          <el-button type="primary" @click="selectGood">确 定</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRedPacket, getSeckillGood, setPacketType } from "@/api/goods";
export default {
  data() {
    return {
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      value: "",
      tableData: [],
      mchId: "",
      goodName: "",
      count: 10,
      currentPage: 1,
      GoodPage: 1,
      centerDialogVisible: false,
      searchValue: "",
      goodsCount: 10,
      goodTableData: [],
    };
  },
  methods: {
    getData() {
      this.mchId = this.$store.getters.mchId;
      console.log(this.mchId);
      let data = {
        mchId: this.mchId,
        page: this.currentPage,
        type: 1,
        isShow: 1,
        size: 10,
        goodName: this.goodName,
      };
      getRedPacket(data).then((res) => {
        this.tableData = res.data.list;
        this.count = Number(res.data.count);
      });
    },
    pageFn() {
      this.getData();
    },
    getGoodList(page) {
      let data = {
        mchId: this.mchId,
        page: this.GoodPage,
        type: 2,
        isShow: 1,
        size: 10,
        goodName: this.searchValue,
      };
      if (page) {
        data.page = page;
      }
      getRedPacket(data).then((res) => {
        this.goodTableData = res.data.list;
        this.goodsCount = Number(res.data.count);
        this.goodTableData.forEach((item) => {
          item.checked = false;
        });
      });
    },
    reset() {
      this.searchValue = "";
      this.getGoodList();
    },
    goodPageFn() {
      console;
      this.getGoodList();
    },
    selectProducts() {
      this.centerDialogVisible = true;
      this.getGoodList();
    },
    handleClick(item) {
      console.log(item);
      let data = {
        goodIds: [],
        type: 2,
      };
      data.goodIds.push(item.goodId);
      setPacketType(data).then((res) => {
        if (res.code == 1) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getData();
        }
      });
    },
    closeFn() {
      this.goodTableData = [];
    },
    selectGood() {
      let that = this;
      this.$confirm("所选商品是否参加实物红包活动？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
      })
        .then(() => {
          let arr = [];
          that.goodTableData.forEach((item) => {
            if (item.checked) {
              arr.push(item.goodId);
            }
          });
          let data = {
            goodIds: arr,
            type: 1,
          };
          setPacketType(data).then((res) => {
            if (res.code == 1) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              that.centerDialogVisible = false;
              that.goodTableData = [];
              that.getData();
            }
          });
          console.log(arr);
        })
        .catch(() => {
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>


<style lang="scss" scoped>
.head {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .head_left {
    display: flex;
    align-items: center;
    span {
      margin-right: 20px;
    }
    .el-select {
      margin-right: 20px;
    }
  }
}
.content {
  margin-top: 50px;
}
.el-pagination{
  display:flex;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/redPacket/redPacket.vue